import Model from './model.js';

export default class BulkUpload extends Model {
    urlRoot() { return '/BulkUploads'; }

    defaults() {
        return {
            companyId: app.company && app.company.id,
            state: 'pending',
            itemCount: 0,
            successes: [],
            uploadErrors: []
        };
    }

    constraints() {
        return {
            file: {presence: {
                message: '^A file is required to do a bulk upload'
            }},
            companyId: {presence: true},
            state: {presence: true}
        };
    } // end of constraints

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    initialize() {
        this.idAttribute = 'objectId';
        return super.initialize(...arguments);
    }
}



// WEBPACK FOOTER //
// ./app/new-models/bulk-upload.js